import React from 'react';
import {
  createHashRouter,
  createRoutesFromElements,
  Route,
} from 'react-router-dom';
import {PrivacyRoute} from './PrivacyRoute';

const router = createHashRouter(
  createRoutesFromElements(
    <Route
      path={'/*'}
      element={<PrivacyRoute />}
      errorElement={<PrivacyRoute />}>
      <Route path="privacy/:lang" element={<PrivacyRoute />}></Route>,
    </Route>,
  ),
);

export {router};
